import { Label } from "@fluentui/react"
import Bolt from "@mui/icons-material/Bolt"

import styles from "./WorkflowBadge.module.css"

import { DEFAULT_BADGE_DESCRIPTION, DEFAULT_BADGE_TITLE } from "./constants"

const DefaultBadge = () => {

    return (
          <div className={`${styles.defaultContainer} ${styles.container}`}>
            <div className={`${styles.defaultIconBackground} ${styles.iconBackground}`}>
              <Bolt className={styles.icon}/>
            </div>
            <div className={styles.defaultTextsColumn}>
                <Label className={styles.defaultTitle}> { DEFAULT_BADGE_TITLE }</Label>
                <div className={styles.defaultDescription}>
                    { DEFAULT_BADGE_DESCRIPTION }
                </div>
            </div>
          </div>
    )
}

export default DefaultBadge
